import React from 'react'

export default function SubjectBar ({subject, percents}) {
  return (
    <div className={`subject ${subject}`}>
      {
        percents[3]
        ? <div className="score-block scored-18-or-above" style={{height: `${parseInt(Math.round(percents[3] * 100), 10) * 4}px`}}>
            <span className="score-number">{`${Math.round(percents[3] * 100)}%`}</span>
          </div>
        : null
      }
      {
        percents[2]
        ? <div className="score-block scored-17" style={{height: `${parseInt(Math.round(percents[2] * 100), 10) * 4}px`}}>
            <span className="score-number">{`${Math.round(percents[2] * 100)}%`}</span>
          </div>
        : null
      }
      {
        percents[1]
        ? <div className="score-block scored-16" style={{height: `${percents[1] * 400}px`}}>
            <span className="score-number">{`${Math.round(percents[1] * 100)}%`}</span>
          </div>
        : null
      }
      {
        percents[0]
        ? <div className="score-block scored-15-or-below" style={{height: `${percents[0] * 400}px`}}>
            <span className="score-number">{`${Math.round(percents[0] * 100)}%`}</span>
          </div>
        : null
      }
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/Threshold/SubjectBar.js